import { render, staticRenderFns } from "./EtapaInformacoesPessoais.vue?vue&type=template&id=408d5041&scoped=true"
import script from "./EtapaInformacoesPessoais.vue?vue&type=script&lang=js"
export * from "./EtapaInformacoesPessoais.vue?vue&type=script&lang=js"
import style0 from "./EtapaInformacoesPessoais.vue?vue&type=style&index=0&id=408d5041&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408d5041",
  null
  
)

export default component.exports